import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1717573152531'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='9597'
        width='200'
        height='200'
    >
        <path
            d='M512 1024C229.70368 1024 0 794.29632 0 512S229.70368 0 512 0s512 229.70368 512 512-229.70368 512-512 512z m0-921.6C286.14656 102.4 102.4 286.14656 102.4 512s183.74656 409.6 409.6 409.6 409.6-183.74656 409.6-409.6S737.85344 102.4 512 102.4z'
            fill='currentColor'
            p-id='9598'
        ></path>
        <path d='M512 204.8v614.4a307.2 307.2 0 0 0 0-614.4z' fill='#333333' p-id='9599'></path>
    </svg>
)

export const SaturationIcon = props => <Icon component={SVG} {...props} />
